import { logger } from "@justhome/common";
import {
  Lead,
  LeadCreationAction,
  usePostLead,
} from "@justhome/common/api/core";
import { Title } from "@justhome/react-ui";
import { FathomEvent } from "@lib/constants";
import useTrackEvent from "@lib/hooks/useTrackEvent";
import { FC, useCallback } from "react";
import LeadWallDetailsForm from "./LeadWallDetailsForm";

interface LeadWallSecondStepProps {
  onSuccess: (lead: Lead) => void;
  onPrevious: VoidFunction;
  leadCreationAction: LeadCreationAction;
  applicationId: string;
  email: string;
}

const LeadWallSecondStep: FC<LeadWallSecondStepProps> = ({
  onSuccess,
  onPrevious,
  leadCreationAction,
  applicationId,
  email,
}) => {
  useTrackEvent(FathomEvent.LEAD_WALL_DETAILS_SEEN);

  const { mutate, isError, isLoading } = usePostLead({
    onSuccess,
    onError: (error) => {
      logger.error("Error while posting a lead.", error);
    },
  });

  const handleSubmit = useCallback(
    (form: Lead) => {
      mutate({
        body: {
          applicationId,
          action: leadCreationAction,
          email: form.email,
          firstName: form.firstName,
          lastName: form.lastName,
          phone: form.phone,
        },
      });
    },
    [mutate, leadCreationAction, applicationId],
  );

  return (
    <>
      <Title className="text-h1 mb-3s">
        Noch ein Schritt zur ```persönlichen Ergebnisseite```
      </Title>

      <LeadWallDetailsForm
        defaultValues={{ email }}
        isError={isError}
        isLoading={isLoading}
        onSubmit={handleSubmit}
        onPrevious={() => onPrevious()}
      />
    </>
  );
};

export default LeadWallSecondStep;
